import { render, staticRenderFns } from "./forward-guide.vue?vue&type=template&id=7da3f64c&scoped=true&"
import script from "./forward-guide.vue?vue&type=script&lang=js&"
export * from "./forward-guide.vue?vue&type=script&lang=js&"
import style0 from "./forward-guide.vue?vue&type=style&index=0&id=7da3f64c&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7da3f64c",
  null
  
)

export default component.exports